export default "__VITE_ASSET__voKyY4iL__"